export default __webpack_public_path__ + "static/media/ReportIcon-Bed-MS.f2eb40a6.jpg";